import { listSalespersonMerchantsMock } from '@fixtures/apis/salesperson/list-salesperson-merchants'
import { MockDebug } from '@tino-frontend/mocks'
import { REACT_APP_SUPPLIER_BFF_API_URL } from 'constants/envs'
import { MockDebugCSAT } from './mocks-msw-checkout'
import { getMerchantInstallmentsMock } from '@fixtures/apis/salesperson/get-merchant-installments'

const MockListSalespersonMerchants: MockDebug = {
  title: 'Meus Clientes - Lista de lojistas',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/salespersons/:salespersonId/merchants`,
  method: 'get',
  delay: 200,
  options: [
    {
      id: 'mock-all-status',
      title: 'Todos os status',
      status: 200,
      data: listSalespersonMerchantsMock.source,
    },
  ],
}

const MockSalespersonMetrics: MockDebug = {
  title: 'Meus Clientes - Métricas de oportunidade',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/salespersons/:salespersonId/metrics`,
  method: 'get',
  delay: 200,
  options: [
    {
      id: 'mock-active-merchants-1',
      title: 'Clientes com limite disponivel',
      status: 200,
      data: {
        total_active_merchants: 4,
        total_available_limit: 123456789,
        new_order_active_merchant: 3,
        new_order_total_available_limit: 10000,
      },
    },
    {
      id: 'mock-active-merchants-2',
      title: 'Sem clientes com limite disponivel',
      status: 200,
      data: {
        total_active_merchants: 0,
        total_available_limit: 0,
        new_order_active_merchant: 0,
        new_order_total_available_limit: 0,
      },
    },
    {
      id: 'mock-active-merchants-3',
      title: 'Clientes com limite disponivel com primeira venda efetuada',
      status: 200,
      data: {
        total_active_merchants: 4,
        total_available_limit: 123456789,
        new_order_active_merchant: 0,
        new_order_total_available_limit: 0,
      },
    },
  ],
}

const MockGetMerchantInstallments: MockDebug = {
  title: 'Boletos do lojista (Merchant Installments)',
  path: `${REACT_APP_SUPPLIER_BFF_API_URL}/v1/suppliers/:supplierId/merchants/:merchantId/installments`,
  method: 'get',
  delay: 200,
  options: [
    {
      id: 'mock-merchant-installments',
      title: 'Boletos em aberto',
      status: 200,
      data: getMerchantInstallmentsMock.source,
    },
  ],
}

export const MockDebugSalespersonApp = [
  MockListSalespersonMerchants,
  MockSalespersonMetrics,
  MockDebugCSAT,
  MockGetMerchantInstallments,
]
